export var NotificationModule;
(function (NotificationModule) {
    NotificationModule["Events"] = "Events";
    NotificationModule["Tasks"] = "Tasks";
    NotificationModule["Activities"] = "Activities";
})(NotificationModule || (NotificationModule = {}));
export const NotificationModuleDisplay = {
    [NotificationModule.Events]: 'Events',
    [NotificationModule.Tasks]: 'Tasks',
    [NotificationModule.Activities]: 'Activities'
};
